module.exports = __webpack_public_path__ + "assets/img/0607.043aac08.png";